import { render, staticRenderFns } from "./Responsible.vue?vue&type=template&id=345137e4&scoped=true"
import script from "./Responsible.vue?vue&type=script&lang=js"
export * from "./Responsible.vue?vue&type=script&lang=js"
import style0 from "./Responsible.vue?vue&type=style&index=0&id=345137e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345137e4",
  null
  
)

export default component.exports